import { BaseEncounterData } from '../types/encounter'
import { Encounter, EncounterType } from '../types'

const ANTEPARTUM_TYPES: ReadonlySet<EncounterType> = new Set([
  EncounterType.ANTEPARTUM,
  EncounterType.POSTPARTUM,
])

/**
 * §2.10.2 / §2.12.2 — Billing-team-only: auto-suggests HCPCS modifiers and POS code
 * based on encounter type and visit location data. Deterministic — no Firestore dependency.
 *
 * Returned values are suggestions only; billing team confirms before claim submission.
 */
export const suggestEncounterModifiers = (
  encounter: Encounter,
): { modifiers: string[]; posCode: string | null } => {
  const base = encounter.data as BaseEncounterData
  const modality = base.visitLocation?.modality
  const location = base.visitLocation?.location
  const patientLocation = base.visitLocation?.patientLocation

  const modifiers: string[] = []

  // TH — Obstetric treatment program (antepartum / postpartum E&M)
  if (ANTEPARTUM_TYPES.has(encounter.type)) {
    modifiers.push('TH')
  }

  // Telehealth modifiers
  if (modality === 'telehealth-video') {
    modifiers.push('95')
  } else if (modality === 'telehealth-audio-only') {
    modifiers.push('93')
  }

  const isTelehealth = modality === 'telehealth-video' || modality === 'telehealth-audio-only'

  // POS codes
  let posCode: string | null = null
  if (location === 'home') {
    // In-person visit at patient home
    posCode = '10'
  } else if (isTelehealth) {
    posCode = patientLocation === 'home' ? '10' : '02'
  }

  return { modifiers, posCode }
}
